<template>
  <div class="left-header head-page">
    <div class="wrapper">
      <div class="title">
        {{ $ml.get(`Crops`) }}
      </div>
      <!-- {{$store.getters['user/data']}} -->
      <!-- <app-btn
        class="add-crop"
        id="add_crop_button"
        @click="addUserCrop"
        :class="{ disabled : ($store.getters['user/data'].id == '8828d302-abfa-482f-9bd5-83d418a8f8b1') }"
      >
        {{ $ml.get(`Add crop`) }}
      </app-btn> -->
    </div>
  </div>
</template>

<script>
export default {
  components: {
    // ░░░░░░░░░░░░░░░░██
    // ░░░░░░░░░░░░░░░░███
    // ░░██░░░░░░░░░░░████
    // ░░███░░░░░░░░░██████
    // ░░████░░░░░░░███████
    // ░░░█████░░░█████●███
    // ░░░░█████▓▓█████████
    // ░░░░░████▓▓████████
    // ░░░░░░███▓▓███████
    // ░░░░░░██▓▓██████
    // ░░░░░██▓▓█████
    // ░░░░██▓▓████
    // ░░░██▓▓███
    // ░░██▓▓██
    // ░██▓▓██
    // ░██▓▓██
    // ░░██▓▓██
    // ░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░██▓▓██
    // ░░██▓▓██
    // ░██▓▓██
    // ░░██▓▓██
    // ░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░██▓▓██
    // ░░██▓▓██
    // ░██▓▓██
    // ░░██▓▓██
    // ░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░██▓▓██
    // ░░██▓▓██
    // ░██▓▓██
    // ░░██▓▓██
    // ░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░██▓▓██
    // ░░██▓▓██
    // ░██▓▓██
    // ░░██▓▓██
    // ░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░██▓▓██
    // ░░██▓▓██
    // ░██▓▓██
    // ░░██▓▓██
    // ░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░██▓▓██
    // ░░██▓▓██
    // ░██▓▓██
    // ░░██▓▓██
    // ░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░██▓▓██
    // ░░██▓▓██
    // ░██▓▓██
    // ░░██▓▓██
    // ░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░██▓▓██
    // ░░██▓▓██
    // ░██▓▓██
    // ░░██▓▓██
    // ░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░██▓▓██
    // ░░██▓▓██
    // ░██▓▓██
    // ░░██▓▓██
    // ░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░██▓▓██
    // ░░██▓▓██
    // ░░██▓▓██
    // ░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░░░██▓▓██
    // ░░░░██▓▓██
    // ░░░██▓▓██
    // ░░██▓▓██
    // ░██▓▓██
    // ░░█▓▓█
    // ░░░▓▓
    // ░░░░▓

  },
  methods: {
    addUserCrop() {
      this.$store.commit('modals/add-crop/open');
    },
  },
}
</script>

<style lang="scss">

.left-header {
  // min-height: 80px;

  display: flex;
  flex-direction: row;
  align-items: center;

  .wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    height: 50px;
    padding-bottom: 10px;

    .title {
      color: #4C5056;
      font-size: 33px;
      line-height: 100%;
      font-weight: bold;
    }

    .add-crop {

    }
  }
}

</style>
